import axios from "axios";

export default function api() {
    return axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}`,
        headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQURNSU4iLCJzdWIiOiJBZG1pbiIsImlhdCI6MTcwNTE1MTc0MiwiZXhwIjo1MzA1MTUxNzQyfQ.2s9AofKi5zA3cLTF1tiB1-mAXO7iVDPguQbA6bfjESM`
        }
    });
}